import dynamic from "next/dynamic";

const BannerDistribution = {
  Recipes: dynamic(() => import("./RecipesBannerDistribution")),
  Default: dynamic(() => import("./BannerDistribution")),
};

export default BannerDistribution;